import React, { useId } from "react";
import {
  ConstructionArt,
  ConstructionStage,
  ConstructionText,
  ConstructionTitle,
} from "./styles";

/** Aviso da aba ASV para PROP / GUARDIAN. */
export default function VegetationSuppressionUnderConstruction() {
  const clipId = useId().replace(/:/g, "");

  return (
    <ConstructionStage>
      <ConstructionArt
        viewBox="0 0 280 200"
        role="img"
        aria-label="Ilustração de área em construção"
      >
        <circle cx="140" cy="102" r="84" fill="var(--accent-soft)" />
        <ellipse cx="140" cy="164" rx="78" ry="9" fill="var(--surface-2)" />

        <path d="M46 150c10-26 20-40 20-40s10 14 20 40H46z" fill="var(--accent)" />
        <rect x="62" y="146" width="8" height="22" rx="2" fill="#6b4b2a" />

        <rect x="108" y="86" width="7" height="78" rx="2" fill="var(--text-secondary)" />
        <rect x="165" y="86" width="7" height="78" rx="2" fill="var(--text-secondary)" />

        <g clipPath={`url(#${clipId})`}>
          <rect x="92" y="58" width="96" height="40" fill="#e2b340" />
          <rect x="92" y="58" width="16" height="40" fill="#243028" />
          <rect x="124" y="58" width="16" height="40" fill="#243028" />
          <rect x="156" y="58" width="16" height="40" fill="#243028" />
        </g>
        <rect
          x="92"
          y="58"
          width="96"
          height="40"
          rx="6"
          fill="none"
          stroke="var(--text-heading)"
          strokeWidth="2.5"
        />
        <defs>
          <clipPath id={clipId}>
            <rect x="92" y="58" width="96" height="40" rx="6" />
          </clipPath>
        </defs>

        <path d="M198 132l16-28 16 28H198z" fill="#e2b340" />
        <rect x="211" y="130" width="6" height="28" rx="1.5" fill="#6b4b2a" />
        <rect x="204" y="156" width="20" height="5" rx="1.5" fill="var(--text-secondary)" />
      </ConstructionArt>
      <ConstructionTitle>Em construção</ConstructionTitle>
      <ConstructionText>
        A supressão de vegetação desta área ainda está em construção.
      </ConstructionText>
    </ConstructionStage>
  );
}
